// extracted by mini-css-extract-plugin
export default {"pointer":"RZu3t_X121h4pYcc1mDC","btn-cancel":"eHRv_U2sfA42jnWuJ1S8"};